import { bpType } from "@core/types/uiType";

export const BP = {
  SM: "sm",
  MD: "md",
  LG: "lg",
} satisfies Record<string, bpType>;

export const BP_WIDTH = {
  [BP["SM"]]: 360,
  [BP["MD"]]: 640,
  [BP["LG"]]: 960,
} satisfies Record<bpType, number>;
